import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AiOrderParserConfig } from '../../../models/ai-order-parser-config';

@Component({
  selector: 'lib-pdf-ai-parser-save-config-modal',
  standalone: false,
  templateUrl: './pdf-ai-parser-save-config-modal.component.html',
  styleUrls: ['./pdf-ai-parser-save-config-modal.component.scss']
})
export class PdfAiParserSaveConfigModalComponent {
  @Input() draft: AiOrderParserConfig = { name: '' };
  @Input() existingNames: string[] = [];

  name = '';
  error = '';

  private translateService = inject(TranslateService);

  constructor(public activeModal: NgbActiveModal) {}

  get nameConflict(): boolean {
    const trimmed = this.name.trim();
    return !!trimmed && this.existingNames.includes(trimmed);
  }

  save(): void {
    const trimmed = this.name.trim();
    if (!trimmed) {
      this.error = this.translateService.instant('AI_PARSER_CONFIG_NAME_REQUIRED');
      return;
    }
    if (this.nameConflict) {
      return;
    }
    const result: AiOrderParserConfig = {
      ...this.draft,
      name: trimmed
    };
    this.activeModal.close(result);
  }

  close(): void {
    this.activeModal.dismiss();
  }
}
